<div class="container-fluid mt-2">
  <p-panel header="Carregar Imagem" styleClass="p-shadow-3">
    <div class="opcoes-imagem">
      <div class="opcao">
        <p-radioButton
          value="1"
          inputId="login"
          [(ngModel)]="tipoImagem"
        ></p-radioButton>
        <label for="login">Fundo Login</label>
      </div>

      <div class="opcao">
        <p-radioButton
          value="2"
          inputId="logo"
          [(ngModel)]="tipoImagem"
        ></p-radioButton>
        <label for="logo">Logo</label>
      </div>

      <div class="opcao">
        <p-radioButton
          value="3"
          inputId="logo_montadora"
          [(ngModel)]="tipoImagem"
        ></p-radioButton>
        <label for="logo_montadora">Logo O.S montadora</label>
      </div>

      <div class="opcao">
        <p-radioButton
          value="4"
          inputId="imagem_auxiliar"
          [(ngModel)]="tipoImagem"
        ></p-radioButton>
        <label for="imagem_auxiliar">Imagem Auxiliar</label>
      </div>
    </div>

    <p-fileUpload
      accept="image/*"
      customUpload="true"
      chooseLabel="Imagem"
      uploadLabel="Enviar"
      cancelLabel="Cancelar"
      (uploadHandler)="onUpload($event)"
    >
    </p-fileUpload>

    <p-messages [(value)]="erro" [enableService]="false"></p-messages>
  </p-panel>
</div>